var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyePupilRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 185.7 185.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".h{opacity:.7;}.i{isolation:isolate;}.j{fill:#3a356d;}.k{fill:url(#f);opacity:.5;}.k,.l{mix-blend-mode:screen;}.m{fill:#fff;opacity:.25;}.n{fill:url(#d);}.o{fill:url(#e);}.p{fill:#871010;}.l{fill:url(#g);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 92.85,
    cy: 92.85,
    fx: 92.85,
    fy: 92.85,
    r: 92.85,
    gradientTransform: "translate(92.85 -38.46) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#e80f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#e40e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d80e29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c40d24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#a80c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#840b13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#600a0a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 92.85,
    cy: 92.85,
    fx: 92.85,
    fy: 92.85,
    r: 88.38,
    gradientTransform: "translate(92.85 -38.46) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#e80f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#e40f2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#d8122d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#c4162d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#a81c2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f1e2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 203.56,
    y1: 142.62,
    x2: 62.99,
    y2: 35.39,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 94.8,
    y1: 308.89,
    x2: 92.63,
    y2: 100.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#282828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#121212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 92.85,
    cy: 92.85,
    r: 92.85,
    transform: "translate(-38.46 92.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 92.85,
    cy: 92.85,
    r: 88.38,
    transform: "translate(-38.46 92.85) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M92.85,32.95c-.36,0-.65-.29-.65-.65v-3c0-.36,.29-.65,.65-.65s.65,.29,.65,.65v3c0,.36-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M92.85,40.2c-.36,0-.65-.29-.65-.65v-5.51c0-.36,.29-.65,.65-.65s.65,.29,.65,.65v5.51c0,.36-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M92.85,56.93c-.36,0-.65-.29-.65-.65v-13.49c0-.36,.29-.65,.65-.65s.65,.29,.65,.65v13.49c0,.36-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M89.98,57.04c-.34,0-.62-.26-.65-.6l-1.13-14.32c-.03-.36,.24-.67,.6-.7,.36-.03,.67,.24,.7,.6l1.13,14.32c.03,.36-.24,.67-.6,.7-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M87.13,57.38c-.32,0-.59-.23-.64-.55l-4.49-28.32c-.06-.36,.19-.69,.54-.75,.36-.06,.69,.19,.75,.54l4.49,28.32c.06,.36-.19,.69-.54,.75-.03,0-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M84.31,57.94c-.29,0-.56-.2-.63-.5l-4.39-18.31c-.08-.35,.13-.7,.48-.79,.35-.08,.7,.13,.79,.48l4.39,18.31c.08,.35-.13,.7-.48,.79-.05,.01-.1,.02-.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M79.45,37.67c-.29,0-.56-.2-.63-.5l-.81-3.38c-.08-.35,.13-.7,.48-.79,.35-.08,.7,.13,.79,.48l.81,3.38c.08,.35-.13,.7-.48,.79-.05,.01-.1,.02-.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M88.6,40.8c-.34,0-.62-.26-.65-.6l-.38-4.82c-.03-.36,.24-.67,.6-.7,.36-.03,.67,.24,.7,.6l.38,4.82c.03,.36-.24,.67-.6,.7-.02,0-.03,0-.05,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M74.14,35.92c-.27,0-.53-.18-.62-.45l-.93-2.85c-.11-.34,.08-.71,.42-.82,.34-.11,.71,.08,.82,.42l.93,2.85c.11,.34-.08,.71-.42,.82-.07,.02-.13,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M76.38,42.81c-.28,0-.53-.18-.62-.45l-1.7-5.24c-.11-.34,.08-.71,.42-.82,.34-.11,.71,.08,.82,.42l1.7,5.24c.11,.34-.08,.71-.42,.82-.07,.02-.14,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M81.55,58.72c-.27,0-.53-.18-.62-.45l-4.17-12.83c-.11-.34,.08-.71,.42-.82,.34-.11,.71,.08,.82,.42l4.17,12.83c.11,.34-.08,.71-.42,.82-.07,.02-.13,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M78.85,59.71c-.26,0-.5-.15-.6-.4l-5.5-13.27c-.14-.33,.02-.71,.35-.85,.33-.14,.71,.02,.85,.35l5.5,13.27c.14,.33-.02,.71-.35,.85-.08,.03-.17,.05-.25,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M76.25,60.91c-.24,0-.47-.13-.58-.36l-13.02-25.55c-.16-.32-.04-.71,.29-.88,.32-.16,.71-.04,.88,.29l13.02,25.55c.16,.32,.04,.71-.29,.88-.09,.05-.2,.07-.3,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M73.74,62.32c-.22,0-.43-.11-.56-.31l-9.84-16.05c-.19-.31-.09-.71,.22-.9,.31-.19,.71-.09,.9,.22l9.84,16.05c.19,.31,.09,.71-.22,.9-.11,.07-.22,.1-.34,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M62.85,44.55c-.22,0-.43-.11-.56-.31l-1.81-2.96c-.19-.31-.09-.71,.22-.9,.31-.19,.71-.09,.9,.22l1.81,2.96c.19,.31,.09,.71-.22,.9-.11,.07-.22,.1-.34,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M72.52,44.69c-.26,0-.5-.15-.6-.4l-1.85-4.47c-.14-.33,.02-.71,.35-.85,.33-.14,.71,.02,.85,.35l1.85,4.47c.14,.33-.02,.71-.35,.85-.08,.03-.17,.05-.25,.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M57.26,44.52c-.2,0-.4-.09-.53-.27l-1.76-2.42c-.21-.29-.15-.7,.14-.91,.29-.21,.7-.15,.91,.14l1.76,2.42c.21,.29,.15,.7-.14,.91-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M61.52,50.38c-.2,0-.4-.09-.53-.27l-3.24-4.46c-.21-.29-.15-.7,.14-.91,.29-.21,.7-.15,.91,.14l3.24,4.46c.21,.29,.15,.7-.14,.91-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M71.35,63.91c-.2,0-.4-.09-.53-.27l-7.93-10.91c-.21-.29-.15-.7,.14-.91,.29-.21,.7-.15,.91,.14l7.93,10.91c.21,.29,.15,.7-.14,.91-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M69.1,65.69c-.18,0-.37-.08-.5-.23l-9.33-10.92c-.23-.27-.2-.69,.07-.92,.27-.23,.69-.2,.92,.07l9.33,10.92c.23,.27,.2,.69-.07,.92-.12,.1-.27,.16-.42,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M66.99,67.64c-.17,0-.33-.06-.46-.19l-20.27-20.28c-.25-.25-.25-.67,0-.92,.25-.25,.67-.25,.92,0l20.27,20.28c.25,.25,.25,.67,0,.92-.13,.13-.29,.19-.46,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M65.04,69.75c-.15,0-.3-.05-.42-.16l-14.31-12.23c-.27-.23-.31-.65-.07-.92,.23-.27,.65-.31,.92-.07l14.31,12.23c.27,.23,.31,.65,.07,.92-.13,.15-.31,.23-.5,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M49.19,56.21c-.15,0-.3-.05-.42-.16l-2.64-2.25c-.27-.23-.31-.65-.07-.92,.23-.27,.65-.31,.92-.07l2.64,2.25c.27,.23,.31,.65,.07,.92-.13,.15-.31,.23-.5,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M58.44,53.36c-.18,0-.37-.08-.5-.23l-3.14-3.67c-.23-.27-.2-.69,.07-.92,.27-.23,.69-.2,.92,.07l3.14,3.67c.23,.27,.2,.69-.07,.92-.12,.1-.27,.16-.42,.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M43.86,57.91c-.13,0-.27-.04-.38-.12l-2.42-1.76c-.29-.21-.36-.62-.14-.91,.21-.29,.62-.36,.91-.14l2.42,1.76c.29,.21,.36,.62,.14,.91-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M49.73,62.17c-.13,0-.27-.04-.38-.12l-4.46-3.24c-.29-.21-.36-.62-.14-.91,.21-.29,.62-.36,.91-.14l4.46,3.24c.29,.21,.36,.62,.14,.91-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M63.26,72c-.13,0-.27-.04-.38-.12l-10.91-7.93c-.29-.21-.36-.62-.14-.91,.21-.29,.62-.36,.91-.14l10.91,7.93c.29,.21,.36,.62,.14,.91-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M61.66,74.39c-.12,0-.23-.03-.34-.1l-12.24-7.5c-.31-.19-.4-.59-.22-.9,.19-.31,.59-.4,.9-.22l12.24,7.5c.31,.19,.4,.59,.22,.9-.12,.2-.34,.31-.56,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M60.26,76.9c-.1,0-.2-.02-.3-.07l-25.55-13.02c-.32-.16-.45-.56-.29-.88,.16-.32,.56-.45,.88-.29l25.55,13.02c.32,.16,.45,.56,.29,.88-.12,.23-.34,.36-.58,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M59.06,79.51c-.08,0-.17-.02-.25-.05l-17.39-7.2c-.33-.14-.49-.52-.35-.85,.14-.33,.52-.49,.85-.35l17.39,7.2c.33,.14,.49,.52,.35,.85-.1,.25-.35,.4-.6,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M39.8,71.53c-.08,0-.17-.02-.25-.05l-3.21-1.33c-.33-.14-.49-.52-.35-.85,.14-.33,.52-.49,.85-.35l3.21,1.33c.33,.14,.49,.52,.35,.85-.1,.25-.35,.4-.6,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M47.72,65.96c-.12,0-.23-.03-.34-.1l-4.12-2.53c-.31-.19-.4-.59-.22-.9,.19-.31,.59-.4,.9-.22l4.12,2.53c.31,.19,.4,.59,.22,.9-.12,.2-.34,.31-.56,.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M35.26,74.79c-.07,0-.13-.01-.2-.03l-2.85-.93c-.34-.11-.53-.48-.42-.82,.11-.34,.48-.53,.82-.42l2.85,.93c.34,.11,.53,.48,.42,.82-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M42.16,77.03c-.07,0-.13-.01-.2-.03l-5.24-1.7c-.34-.11-.53-.48-.42-.82,.11-.34,.48-.53,.82-.42l5.24,1.7c.34,.11,.53,.48,.42,.82-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M58.07,82.2c-.07,0-.13-.01-.2-.03l-12.83-4.17c-.34-.11-.53-.48-.42-.82,.11-.34,.48-.53,.82-.42l12.83,4.17c.34,.11,.53,.48,.42,.82-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M57.29,84.96c-.05,0-.1,0-.15-.02l-13.96-3.35c-.35-.08-.57-.44-.48-.79,.08-.35,.44-.57,.79-.48l13.96,3.35c.35,.08,.57,.44,.48,.79-.07,.3-.34,.5-.63,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M56.73,87.78s-.07,0-.1,0l-28.32-4.49c-.36-.06-.6-.39-.54-.75,.06-.36,.39-.6,.75-.54l28.32,4.49c.36,.06,.6,.39,.54,.75-.05,.32-.33,.55-.64,.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M56.39,90.63s-.03,0-.05,0l-18.77-1.48c-.36-.03-.63-.34-.6-.7,.03-.36,.34-.62,.7-.6l18.77,1.48c.36,.03,.63,.34,.6,.7-.03,.34-.31,.6-.65,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M35.61,89s-.03,0-.05,0l-3.46-.27c-.36-.03-.63-.34-.6-.7,.03-.36,.34-.62,.7-.6l3.46,.27c.36,.03,.63,.34,.6,.7-.03,.34-.31,.6-.65,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M41.42,81.26c-.05,0-.1,0-.15-.02l-4.7-1.13c-.35-.08-.57-.44-.48-.79,.08-.35,.44-.57,.79-.48l4.7,1.13c.35,.08,.57,.44,.48,.79-.07,.3-.34,.5-.63,.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M32.3,93.5h-3c-.36,0-.65-.29-.65-.65s.29-.65,.65-.65h3c.36,0,.65,.29,.65,.65s-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M39.55,93.5h-5.51c-.36,0-.65-.29-.65-.65s.29-.65,.65-.65h5.51c.36,0,.65,.29,.65,.65s-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M56.27,93.5h-13.49c-.36,0-.65-.29-.65-.65s.29-.65,.65-.65h13.49c.36,0,.65,.29,.65,.65s-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M42.07,97.5c-.34,0-.62-.26-.65-.6-.03-.36,.24-.67,.6-.7l14.32-1.13c.36-.03,.67,.24,.7,.6,.03,.36-.24,.67-.6,.7l-14.32,1.13s-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M28.4,103.71c-.32,0-.59-.23-.64-.55-.06-.36,.19-.69,.54-.75l28.32-4.49c.36-.06,.69,.19,.75,.54,.06,.36-.19,.69-.54,.75l-28.32,4.49s-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M38.98,106.44c-.29,0-.56-.2-.63-.5-.08-.35,.13-.7,.48-.79l18.31-4.39c.35-.08,.7,.13,.79,.48,.08,.35-.13,.7-.48,.79l-18.31,4.39c-.05,.01-.1,.02-.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M33.64,107.72c-.29,0-.56-.2-.63-.5-.08-.35,.13-.7,.48-.79l3.38-.81c.35-.08,.7,.13,.79,.48,.08,.35-.13,.7-.48,.79l-3.38,.81c-.05,.01-.1,.02-.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M35.33,98.13c-.34,0-.62-.26-.65-.6-.03-.36,.24-.67,.6-.7l4.82-.38c.36-.03,.67,.24,.7,.6,.03,.36-.24,.67-.6,.7l-4.82,.38s-.03,0-.05,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M32.41,113.14c-.28,0-.53-.18-.62-.45-.11-.34,.08-.71,.42-.82l2.85-.93c.34-.11,.71,.08,.82,.42,.11,.34-.08,.71-.42,.82l-2.85,.93c-.07,.02-.13,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M36.92,111.68c-.28,0-.53-.18-.62-.45-.11-.34,.08-.71,.42-.82l5.24-1.7c.34-.11,.71,.08,.82,.42,.11,.34-.08,.71-.42,.82l-5.24,1.7c-.07,.02-.13,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M45.24,108.97c-.28,0-.53-.18-.62-.45-.11-.34,.08-.71,.42-.82l12.83-4.17c.34-.11,.71,.08,.82,.42,.11,.34-.08,.71-.42,.82l-12.83,4.17c-.07,.02-.13,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M45.79,113c-.26,0-.5-.15-.6-.4-.14-.33,.02-.71,.35-.85l13.27-5.5c.33-.14,.71,.02,.85,.35,.14,.33-.02,.71-.35,.85l-13.27,5.5c-.08,.03-.17,.05-.25,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M34.71,123.12c-.24,0-.47-.13-.58-.36-.16-.32-.04-.71,.29-.88l25.55-13.02c.32-.16,.71-.04,.88,.29,.16,.32,.04,.71-.29,.88l-25.55,13.02c-.09,.05-.2,.07-.3,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M45.61,122.45c-.22,0-.43-.11-.56-.31-.19-.31-.09-.71,.22-.9l16.05-9.84c.31-.19,.71-.09,.9,.22,.19,.31,.09,.71-.22,.9l-16.05,9.84c-.11,.07-.22,.1-.34,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M40.93,125.32c-.22,0-.43-.11-.56-.31-.19-.31-.09-.71,.22-.9l2.96-1.81c.31-.19,.71-.09,.9,.22s.09,.71-.22,.9l-2.96,1.81c-.11,.07-.22,.1-.34,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M39.58,115.68c-.26,0-.5-.15-.6-.4-.14-.33,.02-.71,.35-.85l4.47-1.85c.33-.14,.71,.02,.85,.35,.14,.33-.02,.71-.35,.85l-4.47,1.85c-.08,.03-.17,.05-.25,.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M41.44,130.86c-.2,0-.4-.09-.53-.27-.21-.29-.15-.7,.14-.91l2.42-1.76c.29-.21,.7-.15,.91,.14,.21,.29,.15,.7-.14,.91l-2.42,1.76c-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M45.27,128.07c-.2,0-.4-.09-.53-.27-.21-.29-.15-.7,.14-.91l4.46-3.24c.29-.21,.7-.15,.91,.14,.21,.29,.15,.7-.14,.91l-4.46,3.24c-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M52.35,122.93c-.2,0-.4-.09-.53-.27-.21-.29-.15-.7,.14-.91l10.91-7.93c.29-.21,.7-.15,.91,.14,.21,.29,.15,.7-.14,.91l-10.91,7.93c-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M54.12,126.58c-.18,0-.37-.08-.5-.23-.23-.27-.2-.69,.07-.92l10.92-9.33c.27-.23,.69-.2,.92,.07,.23,.27,.2,.69-.07,.92l-10.92,9.33c-.12,.11-.27,.16-.42,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M46.71,139.64c-.17,0-.33-.06-.46-.19-.25-.25-.25-.67,0-.92l20.27-20.27c.25-.25,.67-.25,.92,0,.25,.25,.25,.67,0,.92l-20.27,20.27c-.13,.13-.29,.19-.46,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M56.87,135.63c-.15,0-.3-.05-.42-.16-.27-.23-.31-.65-.07-.92l12.23-14.31c.23-.27,.65-.31,.92-.07,.27,.23,.31,.65,.07,.92l-12.23,14.31c-.13,.15-.31,.23-.5,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M53.3,139.8c-.15,0-.3-.05-.42-.16-.27-.23-.31-.65-.07-.92l2.25-2.64c.23-.27,.65-.31,.92-.07,.27,.23,.31,.65,.07,.92l-2.25,2.64c-.13,.15-.31,.23-.5,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M49.04,131.06c-.18,0-.37-.08-.5-.23-.23-.27-.2-.69,.07-.92l3.67-3.14c.27-.23,.69-.2,.92,.07,.23,.27,.2,.69-.07,.92l-3.67,3.14c-.12,.11-.27,.16-.42,.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M55.5,144.91c-.13,0-.27-.04-.38-.12-.29-.21-.36-.62-.14-.91l1.76-2.42c.21-.29,.62-.36,.91-.14,.29,.21,.36,.62,.14,.91l-1.76,2.42c-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M58.28,141.08c-.13,0-.27-.04-.38-.12-.29-.21-.36-.62-.14-.91l3.24-4.46c.21-.29,.62-.36,.91-.14,.29,.21,.36,.62,.14,.91l-3.24,4.46c-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M63.42,134c-.13,0-.27-.04-.38-.12-.29-.21-.36-.62-.14-.91l7.93-10.91c.21-.29,.62-.36,.91-.14,.29,.21,.36,.62,.14,.91l-7.93,10.91c-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M66.24,136.93c-.12,0-.23-.03-.34-.1-.31-.19-.4-.59-.22-.9l7.5-12.24c.19-.31,.59-.4,.9-.22,.31,.19,.4,.59,.22,.9l-7.5,12.24c-.12,.2-.34,.31-.56,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M63.23,151.64c-.1,0-.2-.02-.3-.07-.32-.16-.45-.56-.29-.88l13.02-25.55c.16-.32,.56-.45,.88-.29,.32,.16,.45,.56,.29,.88l-13.02,25.55c-.12,.23-.34,.36-.58,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M71.65,144.69c-.08,0-.17-.02-.25-.05-.33-.14-.49-.52-.35-.85l7.2-17.39c.14-.33,.52-.49,.85-.35,.33,.14,.49,.52,.35,.85l-7.2,17.39c-.1,.25-.35,.4-.6,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M69.55,149.76c-.08,0-.17-.02-.25-.05-.33-.14-.49-.52-.35-.85l1.33-3.21c.14-.33,.52-.49,.85-.35,.33,.14,.49,.52,.35,.85l-1.33,3.21c-.1,.25-.35,.4-.6,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M62.78,142.76c-.12,0-.23-.03-.34-.1-.31-.19-.4-.59-.22-.9l2.53-4.12c.19-.31,.59-.4,.9-.22,.31,.19,.4,.59,.22,.9l-2.53,4.12c-.12,.2-.34,.31-.56,.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M73.21,153.94c-.07,0-.13-.01-.2-.03-.34-.11-.53-.48-.42-.82l.93-2.85c.11-.34,.48-.53,.82-.42,.34,.11,.53,.48,.42,.82l-.93,2.85c-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M74.68,149.44c-.07,0-.13-.01-.2-.03-.34-.11-.53-.48-.42-.82l1.7-5.24c.11-.34,.48-.53,.82-.42,.34,.11,.53,.48,.42,.82l-1.7,5.24c-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M77.38,141.11c-.07,0-.13-.01-.2-.03-.34-.11-.53-.48-.42-.82l4.17-12.83c.11-.34,.48-.53,.82-.42,.34,.11,.53,.48,.42,.82l-4.17,12.83c-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M80.96,143.03c-.05,0-.1,0-.15-.02-.35-.08-.57-.44-.48-.79l3.35-13.96c.08-.35,.44-.57,.79-.48,.35,.08,.57,.44,.48,.79l-3.35,13.96c-.07,.3-.34,.5-.63,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M82.64,157.95s-.07,0-.1,0c-.36-.06-.6-.39-.54-.75l4.49-28.32c.06-.36,.39-.6,.75-.54,.36,.06,.6,.39,.54,.75l-4.49,28.32c-.05,.32-.33,.55-.64,.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M88.5,148.73s-.03,0-.05,0c-.36-.03-.63-.34-.6-.7l1.48-18.77c.03-.36,.34-.63,.7-.6,.36,.03,.63,.34,.6,.7l-1.48,18.77c-.03,.34-.31,.6-.65,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M88.07,154.21s-.03,0-.05,0c-.36-.03-.63-.34-.6-.7l.27-3.46c.03-.36,.34-.63,.7-.6,.36,.03,.63,.34,.6,.7l-.27,3.46c-.03,.34-.31,.6-.65,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M79.48,149.64c-.05,0-.1,0-.15-.02-.35-.08-.57-.44-.48-.79l1.13-4.7c.08-.35,.44-.57,.79-.48,.35,.08,.57,.44,.48,.79l-1.13,4.7c-.07,.3-.34,.5-.63,.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M92.85,157.05c-.36,0-.65-.29-.65-.65v-3c0-.36,.29-.65,.65-.65s.65,.29,.65,.65v3c0,.36-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M92.85,152.31c-.36,0-.65-.29-.65-.65v-5.51c0-.36,.29-.65,.65-.65s.65,.29,.65,.65v5.51c0,.36-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M92.85,143.56c-.36,0-.65-.29-.65-.65v-13.49c0-.36,.29-.65,.65-.65s.65,.29,.65,.65v13.49c0,.36-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M96.85,144.28c-.34,0-.62-.26-.65-.6l-1.13-14.32c-.03-.36,.24-.67,.6-.7,.36-.03,.67,.24,.7,.6l1.13,14.32c.03,.36-.24,.67-.6,.7-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M103.06,157.95c-.32,0-.59-.23-.64-.55l-4.49-28.32c-.06-.36,.19-.69,.54-.75,.36-.05,.69,.19,.75,.54l4.49,28.32c.06,.36-.19,.69-.54,.75-.03,0-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M105.78,147.37c-.29,0-.56-.2-.63-.5l-4.39-18.31c-.08-.35,.13-.7,.48-.79,.35-.09,.7,.13,.79,.48l4.39,18.31c.08,.35-.13,.7-.48,.79-.05,.01-.1,.02-.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M107.06,152.71c-.29,0-.56-.2-.63-.5l-.81-3.38c-.08-.35,.13-.7,.48-.79,.35-.09,.7,.13,.79,.48l.81,3.38c.08,.35-.13,.7-.48,.79-.05,.01-.1,.02-.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M97.48,151.02c-.34,0-.62-.26-.65-.6l-.38-4.82c-.03-.36,.24-.67,.6-.7,.36-.03,.67,.24,.7,.6l.38,4.82c.03,.36-.24,.67-.6,.7-.02,0-.03,0-.05,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M112.49,153.94c-.28,0-.53-.18-.62-.45l-.93-2.85c-.11-.34,.08-.71,.42-.82,.34-.11,.71,.08,.82,.42l.93,2.85c.11,.34-.08,.71-.42,.82-.07,.02-.14,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M111.02,149.44c-.28,0-.53-.18-.62-.45l-1.7-5.24c-.11-.34,.08-.71,.42-.82,.34-.11,.71,.08,.82,.42l1.7,5.24c.11,.34-.08,.71-.42,.82-.07,.02-.14,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M108.32,141.11c-.28,0-.53-.18-.62-.45l-4.17-12.83c-.11-.34,.08-.71,.42-.82,.34-.11,.71,.08,.82,.42l4.17,12.83c.11,.34-.08,.71-.42,.82-.07,.02-.14,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M112.34,140.56c-.26,0-.5-.15-.6-.4l-5.5-13.27c-.14-.33,.02-.71,.35-.85,.33-.14,.71,.02,.85,.35l5.5,13.27c.14,.33-.02,.71-.35,.85-.08,.03-.17,.05-.25,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M122.47,151.64c-.24,0-.47-.13-.58-.36l-13.02-25.55c-.16-.32-.04-.71,.29-.88,.32-.16,.71-.04,.88,.29l13.02,25.55c.16,.32,.04,.71-.29,.88-.09,.05-.2,.07-.3,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M121.8,140.74c-.22,0-.43-.11-.56-.31l-9.84-16.05c-.19-.31-.09-.71,.22-.9,.31-.19,.71-.09,.9,.22l9.84,16.05c.19,.31,.09,.71-.22,.9-.11,.07-.22,.1-.34,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M124.67,145.42c-.22,0-.43-.11-.56-.31l-1.81-2.96c-.19-.31-.09-.71,.22-.9,.31-.19,.71-.09,.9,.22l1.81,2.96c.19,.31,.09,.71-.22,.9-.11,.07-.22,.1-.34,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M115.03,146.78c-.26,0-.5-.15-.6-.4l-1.85-4.47c-.14-.33,.02-.71,.35-.85,.33-.14,.71,.02,.85,.35l1.85,4.47c.14,.33-.02,.71-.35,.85-.08,.03-.17,.05-.25,.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M130.2,144.91c-.2,0-.4-.09-.53-.27l-1.76-2.42c-.21-.29-.15-.7,.14-.91,.29-.21,.7-.15,.91,.14l1.76,2.42c.21,.29,.15,.7-.14,.91-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M127.42,141.08c-.2,0-.4-.09-.53-.27l-3.24-4.46c-.21-.29-.15-.7,.14-.91,.29-.21,.7-.15,.91,.14l3.24,4.46c.21,.29,.15,.7-.14,.91-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M122.28,134c-.2,0-.4-.09-.53-.27l-7.93-10.91c-.21-.29-.15-.7,.14-.91,.29-.21,.7-.15,.91,.14l7.93,10.91c.21,.29,.15,.7-.14,.91-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M125.93,132.23c-.18,0-.37-.08-.5-.23l-9.33-10.92c-.23-.27-.2-.69,.07-.92,.27-.23,.69-.2,.92,.07l9.33,10.92c.23,.27,.2,.69-.07,.92-.12,.11-.27,.16-.42,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M138.99,139.64c-.17,0-.33-.06-.46-.19l-20.28-20.27c-.25-.25-.25-.67,0-.92s.67-.25,.92,0l20.28,20.27c.25,.25,.25,.67,0,.92-.13,.13-.29,.19-.46,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M134.98,129.48c-.15,0-.3-.05-.42-.16l-14.31-12.23c-.27-.23-.31-.65-.07-.92,.23-.27,.65-.31,.92-.07l14.31,12.23c.27,.23,.31,.65,.07,.92-.13,.15-.31,.23-.5,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M139.15,133.05c-.15,0-.3-.05-.42-.16l-2.64-2.25c-.27-.23-.31-.65-.07-.92,.23-.27,.65-.31,.92-.07l2.64,2.25c.27,.23,.31,.65,.07,.92-.13,.15-.31,.23-.5,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M130.4,137.32c-.18,0-.37-.08-.5-.23l-3.14-3.67c-.23-.27-.2-.69,.07-.92,.27-.23,.69-.2,.92,.07l3.14,3.68c.23,.27,.2,.69-.07,.92-.12,.11-.27,.16-.42,.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M144.26,130.86c-.13,0-.27-.04-.38-.12l-2.42-1.76c-.29-.21-.36-.62-.14-.91,.21-.29,.62-.36,.91-.14l2.42,1.76c.29,.21,.36,.62,.14,.91-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M140.43,128.07c-.13,0-.27-.04-.38-.12l-4.46-3.24c-.29-.21-.36-.62-.14-.91,.21-.29,.62-.36,.91-.14l4.46,3.24c.29,.21,.36,.62,.14,.91-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M133.35,122.93c-.13,0-.27-.04-.38-.12l-10.91-7.93c-.29-.21-.36-.62-.14-.91,.21-.29,.62-.36,.91-.14l10.91,7.93c.29,.21,.36,.62,.14,.91-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M136.28,120.12c-.12,0-.23-.03-.34-.1l-12.24-7.5c-.31-.19-.4-.59-.22-.9,.19-.31,.59-.4,.9-.22l12.24,7.5c.31,.19,.4,.59,.22,.9-.12,.2-.34,.31-.56,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M150.99,123.12c-.1,0-.2-.02-.3-.07l-25.55-13.02c-.32-.16-.45-.56-.29-.88,.16-.32,.56-.45,.88-.29l25.55,13.02c.32,.16,.45,.56,.29,.88-.12,.23-.34,.36-.58,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M144.03,114.7c-.08,0-.17-.02-.25-.05l-17.39-7.2c-.33-.14-.49-.52-.35-.85,.14-.33,.52-.49,.85-.35l17.39,7.2c.33,.14,.49,.52,.35,.85-.1,.25-.35,.4-.6,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M149.11,116.8c-.08,0-.17-.02-.25-.05l-3.21-1.33c-.33-.14-.49-.52-.35-.85,.14-.33,.52-.49,.85-.35l3.21,1.33c.33,.14,.49,.52,.35,.85-.1,.25-.35,.4-.6,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M142.1,123.57c-.12,0-.23-.03-.34-.1l-4.12-2.53c-.31-.19-.4-.59-.22-.9,.19-.31,.59-.4,.9-.22l4.12,2.53c.31,.19,.4,.59,.22,.9-.12,.2-.34,.31-.56,.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M153.29,113.14c-.07,0-.13-.01-.2-.03l-2.85-.93c-.34-.11-.53-.48-.42-.82,.11-.34,.48-.53,.82-.42l2.85,.93c.34,.11,.53,.48,.42,.82-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M148.78,111.68c-.07,0-.13-.01-.2-.03l-5.24-1.7c-.34-.11-.53-.48-.42-.82,.11-.34,.48-.53,.82-.42l5.24,1.7c.34,.11,.53,.48,.42,.82-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M140.46,108.97c-.07,0-.13-.01-.2-.03l-12.83-4.17c-.34-.11-.53-.48-.42-.82,.11-.34,.48-.53,.82-.42l12.83,4.17c.34,.11,.53,.48,.42,.82-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M142.38,105.39c-.05,0-.1,0-.15-.02l-13.96-3.35c-.35-.08-.57-.44-.48-.79,.08-.35,.44-.57,.79-.48l13.96,3.35c.35,.08,.57,.44,.48,.79-.07,.3-.34,.5-.63,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M157.3,103.71s-.07,0-.1,0l-28.32-4.49c-.36-.06-.6-.39-.54-.75,.06-.36,.39-.6,.75-.54l28.32,4.49c.36,.06,.6,.39,.54,.75-.05,.32-.33,.55-.64,.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M148.08,97.85s-.03,0-.05,0l-18.77-1.48c-.36-.03-.63-.34-.6-.7,.03-.36,.34-.63,.7-.6l18.77,1.48c.36,.03,.63,.34,.6,.7-.03,.34-.31,.6-.65,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M153.55,98.28s-.03,0-.05,0l-3.46-.27c-.36-.03-.63-.34-.6-.7,.03-.36,.34-.63,.7-.6l3.46,.27c.36,.03,.63,.34,.6,.7-.03,.34-.31,.6-.65,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M148.99,106.88c-.05,0-.1,0-.15-.02l-4.7-1.13c-.35-.08-.57-.44-.48-.79,.08-.35,.44-.57,.79-.48l4.7,1.13c.35,.08,.57,.44,.48,.79-.07,.3-.34,.5-.63,.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M156.4,93.5h-3c-.36,0-.65-.29-.65-.65s.29-.65,.65-.65h3c.36,0,.65,.29,.65,.65s-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M151.66,93.5h-5.51c-.36,0-.65-.29-.65-.65s.29-.65,.65-.65h5.51c.36,0,.65,.29,.65,.65s-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M142.91,93.5h-13.49c-.36,0-.65-.29-.65-.65s.29-.65,.65-.65h13.49c.36,0,.65,.29,.65,.65s-.29,.65-.65,.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M129.31,90.63c-.34,0-.62-.26-.65-.6-.03-.36,.24-.67,.6-.7l14.32-1.13c.36-.03,.67,.24,.7,.6,.03,.36-.24,.67-.6,.7l-14.32,1.13s-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M128.97,87.78c-.32,0-.59-.23-.64-.55-.06-.36,.19-.69,.54-.75l28.32-4.49c.35-.06,.69,.19,.75,.54,.06,.36-.19,.69-.54,.75l-28.32,4.49s-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M128.41,84.96c-.29,0-.56-.2-.63-.5-.08-.35,.13-.7,.48-.79l18.31-4.39c.35-.08,.7,.13,.79,.48,.08,.35-.13,.7-.48,.79l-18.31,4.39c-.05,.01-.1,.02-.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M148.68,80.1c-.29,0-.56-.2-.63-.5-.08-.35,.13-.7,.48-.79l3.38-.81c.35-.08,.7,.13,.79,.48,.08,.35-.13,.7-.48,.79l-3.38,.81c-.05,.01-.1,.02-.15,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M145.55,89.25c-.34,0-.62-.26-.65-.6-.03-.36,.24-.67,.6-.7l4.82-.38c.36-.03,.67,.24,.7,.6,.03,.36-.24,.67-.6,.7l-4.82,.38s-.03,0-.05,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M150.44,74.79c-.28,0-.53-.18-.62-.45-.11-.34,.08-.71,.42-.82l2.85-.93c.35-.11,.71,.08,.82,.42,.11,.34-.08,.71-.42,.82l-2.85,.93c-.07,.02-.14,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M143.54,77.03c-.28,0-.53-.18-.62-.45-.11-.34,.08-.71,.42-.82l5.24-1.7c.34-.11,.71,.08,.82,.42,.11,.34-.08,.71-.42,.82l-5.24,1.7c-.07,.02-.14,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M127.64,82.2c-.28,0-.53-.18-.62-.45-.11-.34,.08-.71,.42-.82l12.83-4.17c.35-.11,.71,.08,.82,.42,.11,.34-.08,.71-.42,.82l-12.83,4.17c-.07,.02-.14,.03-.2,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M126.64,79.51c-.26,0-.5-.15-.6-.4-.14-.33,.02-.71,.35-.85l13.27-5.5c.33-.14,.71,.02,.85,.35,.14,.33-.02,.71-.35,.85l-13.27,5.5c-.08,.03-.17,.05-.25,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M125.44,76.9c-.24,0-.47-.13-.58-.36-.16-.32-.04-.71,.29-.88l25.55-13.02c.32-.16,.71-.04,.88,.29,.16,.32,.04,.71-.29,.88l-25.55,13.02c-.09,.05-.2,.07-.3,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M124.04,74.39c-.22,0-.43-.11-.56-.31-.19-.31-.09-.71,.22-.9l16.05-9.84c.31-.19,.71-.09,.9,.22,.19,.31,.09,.71-.22,.9l-16.05,9.84c-.11,.07-.22,.1-.34,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M141.81,63.5c-.22,0-.43-.11-.56-.31-.19-.31-.09-.71,.22-.9l2.96-1.81c.31-.19,.71-.09,.9,.22,.19,.31,.09,.71-.22,.9l-2.96,1.81c-.11,.07-.22,.1-.34,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M141.66,73.18c-.26,0-.5-.15-.6-.4-.14-.33,.02-.71,.35-.85l4.46-1.85c.33-.14,.71,.02,.85,.35,.14,.33-.02,.71-.35,.85l-4.46,1.85c-.08,.03-.17,.05-.25,.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M141.84,57.91c-.2,0-.4-.09-.53-.27-.21-.29-.15-.7,.14-.91l2.42-1.76c.29-.21,.7-.15,.91,.14,.21,.29,.15,.7-.14,.91l-2.42,1.76c-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M135.97,62.17c-.2,0-.4-.09-.53-.27-.21-.29-.15-.7,.14-.91l4.46-3.24c.29-.21,.7-.15,.91,.14,.21,.29,.15,.7-.14,.91l-4.46,3.24c-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M122.44,72c-.2,0-.4-.09-.53-.27-.21-.29-.15-.7,.14-.91l10.91-7.93c.29-.21,.7-.15,.91,.14,.21,.29,.15,.7-.14,.91l-10.91,7.93c-.12,.08-.25,.12-.38,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M120.66,69.75c-.18,0-.37-.08-.5-.23-.23-.27-.2-.69,.07-.92l10.92-9.33c.27-.23,.69-.2,.92,.07,.23,.27,.2,.69-.07,.92l-10.92,9.33c-.12,.1-.27,.16-.42,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M118.71,67.64c-.17,0-.33-.06-.46-.19-.25-.25-.25-.67,0-.92l20.28-20.28c.25-.25,.67-.25,.92,0,.25,.25,.25,.67,0,.92l-20.28,20.28c-.13,.13-.29,.19-.46,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M116.6,65.69c-.15,0-.3-.05-.42-.16-.27-.23-.31-.65-.07-.92l12.23-14.31c.23-.27,.65-.31,.92-.07,.27,.23,.31,.65,.07,.92l-12.23,14.31c-.13,.15-.31,.23-.5,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M130.14,49.84c-.15,0-.3-.05-.42-.16-.27-.23-.31-.65-.07-.92l2.25-2.64c.23-.27,.65-.31,.92-.07,.27,.23,.31,.65,.07,.92l-2.25,2.64c-.13,.15-.31,.23-.5,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M132.99,59.09c-.18,0-.37-.08-.5-.23-.23-.27-.2-.69,.07-.92l3.68-3.14c.27-.23,.69-.2,.92,.07,.23,.27,.2,.69-.07,.92l-3.67,3.14c-.12,.1-.27,.16-.42,.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M128.44,44.52c-.13,0-.27-.04-.38-.12-.29-.21-.36-.62-.14-.91l1.76-2.42c.21-.29,.62-.36,.91-.14,.29,.21,.36,.62,.14,.91l-1.76,2.42c-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M124.18,50.38c-.13,0-.27-.04-.38-.12-.29-.21-.36-.62-.14-.91l3.24-4.46c.21-.29,.62-.36,.91-.14,.29,.21,.36,.62,.14,.91l-3.24,4.46c-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M114.35,63.91c-.13,0-.27-.04-.38-.12-.29-.21-.36-.62-.14-.91l7.93-10.91c.21-.29,.62-.36,.91-.14,.29,.21,.36,.62,.14,.91l-7.93,10.91c-.13,.18-.33,.27-.53,.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M111.96,62.32c-.12,0-.23-.03-.34-.1-.31-.19-.4-.59-.22-.9l7.5-12.24c.19-.31,.59-.4,.9-.22,.31,.19,.4,.59,.22,.9l-7.5,12.24c-.12,.2-.34,.31-.56,.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M109.45,60.91c-.1,0-.2-.02-.3-.07-.32-.16-.45-.56-.29-.88l13.02-25.55c.16-.32,.56-.45,.88-.29,.32,.16,.45,.56,.29,.88l-13.02,25.55c-.12,.23-.34,.36-.58,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M106.85,59.71c-.08,0-.17-.02-.25-.05-.33-.14-.49-.52-.35-.85l7.2-17.39c.14-.33,.52-.49,.85-.35,.33,.14,.49,.52,.35,.85l-7.2,17.39c-.1,.25-.35,.4-.6,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M114.82,40.45c-.08,0-.17-.02-.25-.05-.33-.14-.49-.52-.35-.85l1.33-3.21c.14-.33,.52-.49,.85-.35,.33,.14,.49,.52,.35,.85l-1.33,3.21c-.1,.25-.35,.4-.6,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M120.39,48.37c-.12,0-.23-.03-.34-.1-.31-.19-.4-.59-.22-.9l2.53-4.12c.19-.31,.59-.4,.9-.22,.31,.19,.4,.59,.22,.9l-2.53,4.12c-.12,.2-.34,.31-.56,.31Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M111.56,35.92c-.07,0-.13-.01-.2-.03-.34-.11-.53-.48-.42-.82l.93-2.85c.11-.34,.48-.53,.82-.42,.34,.11,.53,.48,.42,.82l-.93,2.85c-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M109.32,42.81c-.07,0-.13-.01-.2-.03-.34-.11-.53-.48-.42-.82l1.7-5.24c.11-.34,.48-.53,.82-.42,.34,.11,.53,.48,.42,.82l-1.7,5.24c-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M104.15,58.72c-.07,0-.13-.01-.2-.03-.34-.11-.53-.48-.42-.82l4.17-12.83c.11-.34,.48-.53,.82-.42,.34,.11,.53,.48,.42,.82l-4.17,12.83c-.09,.28-.35,.45-.62,.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M101.39,57.94c-.05,0-.1,0-.15-.02-.35-.08-.57-.44-.48-.79l3.35-13.96c.08-.35,.44-.57,.79-.48,.35,.08,.57,.44,.48,.79l-3.35,13.96c-.07,.3-.34,.5-.63,.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M98.57,57.38s-.07,0-.1,0c-.36-.06-.6-.39-.54-.75l4.49-28.32c.06-.36,.39-.6,.75-.54,.36,.06,.6,.39,.54,.75l-4.49,28.32c-.05,.32-.33,.55-.64,.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M95.72,57.04s-.03,0-.05,0c-.36-.03-.63-.34-.6-.7l1.48-18.77c.03-.36,.34-.62,.7-.6,.36,.03,.63,.34,.6,.7l-1.48,18.77c-.03,.34-.31,.6-.65,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M97.36,36.26s-.03,0-.05,0c-.36-.03-.63-.34-.6-.7l.27-3.46c.03-.36,.34-.63,.7-.6,.36,.03,.63,.34,.6,.7l-.27,3.46c-.03,.34-.31,.6-.65,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M105.1,42.07c-.05,0-.1,0-.15-.02-.35-.08-.57-.44-.48-.79l1.13-4.7c.08-.35,.44-.57,.79-.48,.35,.08,.57,.44,.48,.79l-1.13,4.7c-.07,.3-.34,.5-.63,.5Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 92.85,
    cy: 92.85,
    r: 46.27,
    transform: "translate(-26.17 148.32) rotate(-69.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M79.04,100.81c40.13,0,75.33-21.06,95.17-52.73C158.41,19.42,127.9,0,92.85,0,49.17,0,12.54,30.16,2.64,70.8c20.03,18.63,46.89,30.02,76.4,30.02Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 121.82,
    cy: 130.99,
    r: 12.95,
    transform: "translate(-45.82 193.4) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 67.14,
    cy: 66.72,
    r: 24.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 93.11,
    cy: 146.13,
    rx: 53.53,
    ry: 31.1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyePupilRed);
export default __webpack_public_path__ + "static/media/eye_pupil_red.2b7108711ea5f47388d29b4b586664d3.svg";
export { ForwardRef as ReactComponent };